module.exports = __webpack_public_path__ + "static/img/wyyMusic.3af69cdf.png";